var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion",class:{ 'is-closed' : _vm.isClosed }},[_c('h3',{staticClass:"accordion-title",on:{"click":_vm.toggleOpen}},[_vm._v(_vm._s(_vm.accordionTitle))]),_c('div',{ref:"accordionContent",staticClass:"accordion-content",style:({ height : _vm.accordionHeight }),domProps:{"innerHTML":_vm._s(_vm.accordionContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }